function renderWishlistHeader() {
  
    var spanElement = document.querySelector(".swym-hidden-counter");
    var headerElements = document.querySelectorAll(".swym-wishlist");
  
    if(window._swat && window._swat.renderWishlistCount){
      window._swat.renderWishlistCount(spanElement, function(cnt, elem){
        headerElements.forEach(function(hElement){
          if(cnt == 0){
            if(hElement.classList.contains("swym-added-header")){
              hElement.classList.remove("swym-added-header");
               $(hElement).html('&#x1002b4;');
            }
          }else{
            if (!hElement.classList.contains("swym-added-header")) {
              hElement.classList.add("swym-added-header");
              $(hElement).html('&#x1002b5;');
            }
          }
        });
        
        setTimeout(function(){
          window._swat.fetchWrtEventTypeET(
            function(r) {
              var html = '';
              $.each(r,function(i){
                var title = r[i].dt;
                var link = r[i].du;
                html += '<li><a href="'+link+'">'+title+'</a></li>';
              });
              if(r.length > 0){
              	$("#favorites").html(html);
              }else{
                $("#favorites").html('<li><a href="javascript:void(0)">empty</a></li>');
              }
              console.log(r);
            },
            window._swat.EventTypes.addToWishList
          );
        },300);
        
      });
    } 
}
function swymCallbackFn(swat){
  // your API calls go here
  document.addEventListener("swym:collections-loaded", function(){
    swat.initializeActionButtons(".swym-container");
  });
  renderWishlistHeader();
}

if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
} else {
    renderWishlistHeader();
}

window.SwymCallbacks.push(swymCallbackFn);

